export default __webpack_public_path__ + "static/media/termag-logo-veliki.0c7aed52.png";